// extracted by mini-css-extract-plugin
module.exports = {"show-phone":"dece2e673c--show-phone--3fJ-H"};